<!-- レシート表示画面 -->
<template>
  <div id="container" class="vQrCode">
    <!-- メッセージモーダル -->
    <MessageDialog :name="dialogs.msgDialog.name" :title="dialogs.msgDialog.title" :text="dialogs.msgDialog.text" @event-dialog-close="closeModal">
    </MessageDialog>
    <HeaderLogo></HeaderLogo>
    <main class="contents entry">
      <ContentsTop :title="contentsTop.title" :text="contentsTop.text"></ContentsTop>
      <form class="mainForm">
        <p class="item_info">海外在住に関する情報</p>
        <div class="pBox rightBox">
          <div class="resident_certificate hand">
            <p class="enter_date">
              <label for="enter_date" class="enter_date">直近の入国日（帰国日）</label><span class="colon">：</span>
              <span class="viewport" :class="isPlaceholder(landDate)" @click="onClickLandDateViewport">{{ labels.getDateLabelOrPlaceholder(landDate) }}</span>
              <v-date-picker v-model="landDate"
                :mode="'single'"
                :color="'red'"
                :input-props="{ class: 'enter_date', name: 'enter_date', readonly: true }"
                :popover="{ placement: 'bottom', visibility: 'focus' }"
              >
              </v-date-picker>
            </p>
            <p class="resident_certificate_type">
              <label class="resident_certificate_type">証明書の種類</label><span class="colon">：</span>
              <input type="radio" id="supplementary_family_register" name="resident_certificate_type" value="1" v-model="type">
              <label class="type" for="supplementary_family_register">戸籍附票</label>
              <input type="radio" id="overseas_staying_verification" name="resident_certificate_type" value="2" v-model="type">
              <label class="type" for="overseas_staying_verification">海外在留証明</label>
            </p>
            <p class="issue_date">
              <label for="issue_date" class="issue_date">発行日</label><span class="colon issue_date">：</span>
              <span class="viewport" :class="isPlaceholder(issueDate)" @click="onClickIssueDateViewport">{{ labels.getDateLabelOrPlaceholder(issueDate) }}</span>
              <v-date-picker v-model="issueDate"
                :mode="'single'"
                :color="'red'"
                :input-props="{ class: 'issue_date', name: 'issue_date', readonly: true }"
                :popover="{ placement: 'bottom', visibility: 'focus' }"
              >
              </v-date-picker>
              <span class="explanation">*証明書類の発行日は、直近帰国日から起算して6ヶ月前の日以後であること。</span>
            </p>
            <p class="living_date">
              <label for="living_date" class="living_date">国外に住所を定めた日</label><span class="colon">：</span>
              <span class="viewport" :class="isPlaceholder(livingDate)" @click="onClickLivingDateViewport">{{ labels.getDateLabelOrPlaceholder(livingDate) }}</span>
              <v-date-picker v-model="livingDate"
                :mode="'single'"
                :color="'red'"
                :input-props="{ class: 'living_date', name: 'living_date', readonly: true }"
                :popover="{ placement: 'bottom', visibility: 'focus' }"
              >
              </v-date-picker>
              <span class="explanation">*国外に住所を定めた日は、証明書の発行日から起算して2年以前であること。</span>
            </p>
            <p class="permanent_domicile">
              <label for="permanent_domicile" class="permanent_domicile">本籍地</label><span class="colon permanent_domicile">：</span>
              <input type="text" name="permanent_domicile" class="permanent_domicile" v-model="domicile" placeholder="例）東京都渋谷区恵比寿2丁目3番地" maxlength="80">
            </p>
            <p class="issue_source_official_residence_name" v-show="Number(type) == 2">
              <label for="issue_source_official_residence_name" class="issue_source_official_residence_name">発行元公館名</label><span class="colon">：</span>
              <input type="text" name="issue_source_official_residence_name" class="issue_source_official_residence_name" v-model="source" placeholder="例）在アメリカ合衆国日本国総領事館" maxlength="20">
            </p>
            <p class="issue_number" v-show="Number(type) == 2">
              <label for="issue_number" class="issue_number">発行番号</label><span class="colon">：</span>
              <input type="text" name="issue_number" class="issue_number" v-model="number" maxlength="20">
            </p>
          </div>
        </div>
        <div class="sendBtn_box">
          <a @click="nextPage('downloadQrCode')" class="sendBtn backorange next">QRコードを作成する</a>
        </div>
      </form>
      <div class="caution">{{ caution }}</div>
    </main>
    <Footer></Footer>
  </div>
</template>
<style>
@import "../assets/css/create_qr_code.css";
</style>
<script>
import common from '@/components/Common.vue';
import HeaderLogo from '@/components/HeaderLogo.vue';
import Footer from '@/components/Footer.vue';
import ContentsTop from '@/components/ContentsTop.vue';
import MessageDialog from '@/components/dialogs/MessageDialog.vue';
import QrCodeModel from '../utils/qrCode';
import Labels from '../utils/labels';
import MessageDefine from '../utils/messages';

export default {
  name: 'CreateQrCode',
  mixins: [common],
  components: {
    HeaderLogo,
    Footer,
    ContentsTop,
    MessageDialog,
  },
  data() {
    return {
      landDate: '',
      type: '',
      issueDate: '',
      livingDate: '',
      domicile: '',
      source: '',
      number: '',
      qrCodeModel: QrCodeModel,
      labels: Labels,
      messageDefine: MessageDefine,

      dialogs: {
        msgDialog: {
          name: 'msgDialog',
          title: MessageDefine.title.info,
          text: [''],
        },
      },
      contentsTop: {
        title: MessageDefine.title.qrCode,
        text: MessageDefine.body.createQrCodeTop,
      },
      caution: MessageDefine.body.caution,
    };
  },
  created() {
    // 証明書情報の初期化
    this.$store.commit('setCertificateInfo', { certificateInfo: null });
  },
  computed: {
    isPlaceholder() {
      return (key) => {
        return {
          'is-placeholder': (!key),
        };
      };
    },
  },
  methods: {
    /**
     * 確認モーダルを閉じる
     */
    closeModal() {
      this.$modal.hide('msgDialog');
    },
    /**
     * 直近の入国日（帰国日）のviewportクリック時
     */
    onClickLandDateViewport() {
      window.document.querySelector("input[name='enter_date']").focus();
    },
    /**
     * 発行日のviewportクリック時
     */
    onClickIssueDateViewport() {
      window.document.querySelector("input[name='issue_date']").focus();
    },
    /**
     * 国外に住所を定めた日のviewportクリック時
     */
    onClickLivingDateViewport() {
      window.document.querySelector("input[name='living_date']").focus();
    },
    /**
     * 次へ
     */
    nextPage(path) {
      const certificateInfo = {
        landDate: this.labels.getDateLabelYYYYMMDD(this.landDate),
        type: this.type,
        issueDate: this.labels.getDateLabelYYYYMMDD(this.issueDate),
        livingDate: this.labels.getDateLabelYYYYMMDD(this.livingDate),
        domicile: this.domicile,
        source: this.source,
        number: this.number,
      };
      // 入力チェック
      const requireErrors = this.qrCodeModel.validationCertificateInput(certificateInfo);
      // 必須チェック
      if (requireErrors.length) {
        this.dialogs.msgDialog.text = [];
        requireErrors.forEach((item) => {
          const text = this.messageDefine.body[`${item}Empty`];
          this.dialogs.msgDialog.text = this.dialogs.msgDialog.text.concat(text);
        });
        this.dialogs.msgDialog.title = this.messageDefine.title.info;
        this.$modal.show('msgDialog');
        return;
      }
      // 発行日が未来日でないかのチェック
      if (this.qrCodeModel.checkFutureIssueDate(certificateInfo.issueDate)) {
        this.dialogs.msgDialog.title = this.messageDefine.title.issueInfo;
        this.dialogs.msgDialog.text = this.messageDefine.body.futureIssueDate;
        this.$modal.show('msgDialog');
        return;
      }
      // 国外に住所を定めた日が過去日付かチェック
      if (!this.qrCodeModel.checkPastDate(certificateInfo.livingDate)) {
        this.dialogs.msgDialog.title = this.messageDefine.title.livingDateInfo;
        this.dialogs.msgDialog.text = this.messageDefine.body.pastDate;
        this.$modal.show('msgDialog');
        return;
      }
      // 直近の入国日（帰国日）と発行日の差分チェック
      if (this.qrCodeModel.checkDiffLandDateAndIssueDate(certificateInfo.landDate, certificateInfo.issueDate)) {
        this.dialogs.msgDialog.title = this.messageDefine.title.issueInfo;
        this.dialogs.msgDialog.text = this.messageDefine.body.landDateAndIssueDate;
        this.$modal.show('msgDialog');
        return;
      }
      // 発行日と国外に住所を定めた日の差分チェック
      if (this.qrCodeModel.checkDiffIssueDateAndLivingDate(certificateInfo.issueDate, certificateInfo.livingDate)) {
        this.dialogs.msgDialog.title = this.messageDefine.title.livingDateInfo;
        this.dialogs.msgDialog.text = this.messageDefine.body.issueDateAndLivingDate;
        this.$modal.show('msgDialog');
        return;
      }

      // storeに保存
      this.$store.commit('setCertificateInfo', { certificateInfo });
      this.next({ path });
    },
  },
};
</script>
